"use client";
import { useRouter } from "@/i18n/routing";
import { Mask } from "antd-mobile";
import clsx from "clsx";
import React from "react";
import dialogManage from "../manager";
import styles from "./index.module.scss";

const ImgDialog = () => {
    const keyName = "AlertDialog"; // 确保这个keyName是唯一的，与其他地方的keyName不同，以避免冲突
    const [data, setData] = React.useState<any>({});
    const [visible, setVisible] = React.useState<boolean>(false); // 初始值为false，不显示对话框

    const router = useRouter();

    const handler = {
        key: keyName,
        show(data: any, idx: number) {
            if (!data) return "close";
            setData(data);
            setVisible(true);
        },
        hide() {
            setVisible(false);
        },
    };
    React.useEffect(() => {
        dialogManage.registerDialog(handler);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const close = () => {
        dialogManage.hideDialog(keyName);
    };

    const doConfirm = () => {
        if (typeof data?.onConfirm === "function") {
            data?.onConfirm();
        }
    };
    //点击功能, 1:无功能,2:跳转外部链接,3:跳转页面,4:跳转弹窗,5:跳转打开游戏,6:跳转Live Chat客服,7:跳转内部文档

    return (
        <>
            <Mask visible={visible} onMaskClick={close}>
                <div className={styles.imgDialog}>
                    <div className={styles.imgDialogContainer}>
                        <div>
                            <div>{data.content}</div>
                            <div className={styles.footer}>
                                <button className={styles.footerbtn} onClick={doConfirm}>
                                    {data.footerText || "confirm"}
                                </button>
                            </div>
                        </div>
                        <div className={clsx(styles.close)} onClick={close}>
                            <i
                                className={clsx("iconfont icon-guanbi relative z-10 text-[.14rem]")}
                            ></i>
                        </div>
                    </div>
                </div>
            </Mask>
        </>
    );
};

export default ImgDialog;
